import * as angular from "angular";
import {IController} from "angular";
import {BranchesAlerts} from "../../services/branches-alerts.service";
import {BranchesDialogService} from "../../services/branches-dialogs-service.service";
import {BranchesRequests} from "../../services/branches-requests.service";
import {BranchesService} from "../../services/branches-service.service";
import {ConfirmDialogService} from "../../../commons/services/confirm-dialog.service";
import {BranchModel} from "../../models/branch.model";
import {GroupsService} from "../../../groups/services/groups.service";
import {GroupsDialogService} from "../../../groups/services/groups-dialog.service";
import {SiteFiltersType} from "../../../commons/types/site-filters.type";
import {TagType} from "../../../tags/angular/types/tag.type";

export class branchesViewCtrl implements IController {

  ids?: string[];
  tags?: string[];
  groupIds?: string[];

  private doReload = undefined;
  private queryString = undefined;
  public selectedIds: string[];
  public excludeMode: boolean;
  public totalBranches: any;
  public filtersConfig: any;


  /* @ngInject */
  constructor(private branchesDialogService: BranchesDialogService, private branchesRequests: BranchesRequests, private branchesService: BranchesService,
              private branchesAlerts: BranchesAlerts, private $log, private confirmDialogService: ConfirmDialogService, private groupsService: GroupsService,
              private groupsDialogService: GroupsDialogService, private $state) {
  }

  $onInit() {
    this.filtersConfig = {
      includeFilters: [
        SiteFiltersType.branchIds,
        SiteFiltersType.groupIds,
        SiteFiltersType.tags,
        SiteFiltersType.isActive
      ],
      bringozFilters: {
        [SiteFiltersType.tags]: this.tags || [],
        [SiteFiltersType.branchIds]: this.ids || [],
        [SiteFiltersType.groupIds]: this.groupIds || [],
        [SiteFiltersType.isActive]: undefined
      },
      queryMap: {
        tagType: TagType.Branch
      },
    };
    this._reloadTotalBranches();
  }

  onCreateBranch(event) {
    this.branchesDialogService.createBranch(event)
      .then((branchToCreate) => {
        return this.branchesRequests.createBranch(branchToCreate);
      })
      .then((createdBranch) => {
        this.branchesAlerts.createSuccess();
        this.doReload = true;
      })
      .catch((error) => {
        if (error) {
          this.branchesAlerts.createError();
          this.$log.error('Failed to create branch @branchesView@onCreateBranch', error);
        } else {
          this.$log.info('Dialog Closed');
        }
      });
  }

  onFiltersChange(filters) {
    this.filtersConfig.bringozFilters = filters;
    this._setQueryParams();
    this._reloadTotalBranches();
  }

  onReloadBranches() {
    this.doReload = undefined;
    this._reloadTotalBranches();
  }

  onEditBranch(branch: BranchModel, event) {

  }

  onDeleteBranch(branch: BranchModel, event) {
    this.confirmDialogService.confirm('Remove Branch', 'Are you sure you want to remove this branch?', event)
      .then(() => {
        this._deleteBranch(branch.id);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onQueryChange(query) {
    this.queryString = query;
  }

  onSelectBranchesChange(selectedIds, excludeMode) {
    this.selectedIds = selectedIds;
    this.excludeMode = excludeMode;
  }

  onAddBranchesToGroup() {
    this.groupsDialogService.addBranchesToGroup()
      .then((groupId) => {
        const selectedIds = this.excludeMode ? [] : this.selectedIds;
        const excludedIds = this.excludeMode ? this.selectedIds : [];
        return this.groupsService.addBranchesToGroup(groupId, selectedIds, this.queryString, excludedIds, this.filtersConfig.bringozFilters.tags);
      })
  }

  onEditTags(event) {
    this.branchesDialogService.editTags(event)
      .then(tags => {

        const selectedIds = this.excludeMode ? [] : this.selectedIds;
        const excludedIds = this.excludeMode ? this.selectedIds : [];
        let params: any = {};

        if (!!this.excludeMode) {
          params.tags = this.filtersConfig.bringozFilters.tags;
          params.branchIds = this.filtersConfig.bringozFilters.branchIds;

          if (!!this.queryString) {
            params.query = this.queryString;
          }
        }

        this.branchesService.editTags(tags, params, selectedIds, excludedIds)
          .then(() => {
            this.doReload = true;
            this._reloadTotalBranches();
          })
      })
  }

  private _reloadTotalBranches() {
    this.totalBranches = undefined;
    this.branchesService.getTotalBranches(this.filtersConfig.bringozFilters.branchIds, this.filtersConfig.bringozFilters.tags, this.queryString, this.filtersConfig.bringozFilters.isActive)
      .then((total: any) => {
        this.totalBranches = total.total;
      })
      .catch((error) => {
        this.$log.debug('Failed to reload total accounts', error);
      })
  }

  private _deleteBranch(branchId) {
    this.branchesService.deleteBranch(branchId)
      .then(() => {
        this.doReload = true;
      })
      .catch((error) => {
        this.$log.error('Failed to delete branch @branchesView@onDeleteBranch', error);
      });
  }

  private _setQueryParams() {
    this.$state.go('.', {
      branchIds: this.filtersConfig.bringozFilters.branchIds,
      groupIds: this.filtersConfig.bringozFilters.groupIds,
      tags: this.filtersConfig.bringozFilters.tags
    }, {
      notify: false,
      reload: false
    })
  }

}

angular
  .module('bringoz.admin.branches')
  .component('branchesView', {
    bindings: {
      ids: '<?',
      tags: '<?',
      groupIds: '<?'
    },
    template: require('./branches-view.html').default,
    controller: branchesViewCtrl
  });
